import React, { forwardRef } from 'react';

import type { UUID } from '@aline/common';
import { CircularProgress, Typography } from '@mui/material';
import type { VariantType } from 'notistack';
import { BaseSnackbar } from 'src/components';

interface LoadingSnackbarProps {
  id: UUID;
  message: string;
  variant?: VariantType;
}

export const LoadingSnackbar = forwardRef<HTMLDivElement, LoadingSnackbarProps>(
  function LoadingSnackbar(
    { id, message, variant = 'info' }: LoadingSnackbarProps,
    ref
  ): JSX.Element {
    return (
      <BaseSnackbar ref={ref} action={<CircularProgress size={20} />} id={id} variant={variant}>
        <Typography variant="caption">{message}</Typography>
      </BaseSnackbar>
    );
  }
);
